import classNames from 'classnames';
import styles from './style.m.less';

type Props = {
    label?: React.ReactNode;
    withLabel?: boolean;
    className?: string;
};

export default function LoadingBar({ label = 'Loading…', withLabel = true, className }: Props) {
    const containerClasses = classNames(styles.container, className);
    return (
        <div className={containerClasses}>
            <div className={styles.bar} />
            {withLabel && <small className={styles.label}>{label}</small>}
        </div>
    );
}
